export default "__VITE_ASSET__Bk3zg3Pk__"